/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/FirstRunExperience/Steps/FirstRunExperienceStep.Props" />
export enum StepStatus {
    NotStarted,
    Started,
    Processing,
    Succeeded,
    Failed
}

export interface IFirstRunExperienceStepBasicProps {
    stepId: number;
    activeStepId: number;
}

export interface IFirstRunExperienceStepProps extends IFirstRunExperienceStepBasicProps {
    onRenderTitle: (status: StepStatus) => JSX.Element | string | undefined;
    onRenderContent?: (status: StepStatus) => JSX.Element | string | undefined;
    onRenderError?: () => JSX.Element | string | undefined;
    onRenderHelpLinks?: (status: StepStatus) => JSX.Element | undefined;
    actionButtonText?: string;
    stepProcessingText?: string;
    onActionButtonClicked?: () => Promise<StepStatus>;
}
